export default __webpack_public_path__ + "static/media/nike.7b0320b6.svg";